import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=0f30b1c7&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=0f30b1c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f30b1c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f30b1c7')) {
      api.createRecord('0f30b1c7', component.options)
    } else {
      api.reload('0f30b1c7', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=0f30b1c7&scoped=true&", function () {
      api.rerender('0f30b1c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/loading.vue"
export default component.exports